<template>
  <v-container fill-height fluid grid-list-xl>
    <v-form ref="form" v-model="validForm" class="spm_upsert" v-if="!loadError">

      <v-layout justify-left wrap white>
        <v-flex xs12 sm2 md2>
          <v-text-field
            label="Case Identification Number"
            v-model="cin"
            disabled
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-select
            clearable
            md4
            v-model="selectedProtocol"
            :items="protocols"
            label="Protocol"
            :rules="validators.spm.protocol"
            item-value="id"
            item-text="name"
            return-object
            :disabled="!isNew"
            :readonly="!$can('upsert', 'spm')"
             @change="calculateCin();searchCenter()"
          ></v-select>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-text-field
            label="Patient"
            :disabled="!isNew && !warningMode"
            v-model="item.patient_id"
            :rules="validators.spm.patient"
            @input="searchCenter()"
            @change="calculateCin()"
            :readonly="!$can('upsert', 'spm')"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-autocomplete
            md4
            clearable
            :search-input.sync="siteSearchString"
            v-model="selectedSite"
            :items="sites"
            color="primary"
            hide-no-data
            item-text="name"
            item-value="id"
            label="Site"
            return-object
            prepend-icon="mdi-database-search"
            :loading="loadingSites"
            :disabled="(!isNew && !warningMode) || !item.protocol_id"
            :rules="validators.spm.site"
            :readonly="!$can('upsert', 'spm')"
            @change="calculateCin()"
          >
            <template slot="item" slot-scope="{ item }">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                <v-list-tile-sub-title>{{item.city}} ({{
                  item.country_code
                }})</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-select
            clearable
            required
            label="Case Type"
            v-model="item.case_type"
            :rules="validators.spm.case_type"
            :items="['Initial', 'Follow up']"
            :disabled="!isNew && !warningMode"
            :readonly="!$can('upsert', 'spm')"
            @change="calculateCin()"
          ></v-select>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-menu
            v-model="menu_datePicker_report_date"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="!isNew && !warningMode"
            :readonly="!$can('upsert', 'spm')"
          >
            <template slot="activator">
              <v-text-field
                clearable
                v-model="item.report_date"
                label="Report Date"
                :disabled="!isNew && !warningMode"
                readonly
                :rules="validators.spm.report_date"
              ></v-text-field>
            </template>
            <v-date-picker
              :disabled="!isNew && !warningMode"
              dark
              v-model="item.report_date"
              no-title
              @_change="calculateCin()"
              @input="menu_datePicker_report_date = false"
              :readonly="!$can('upsert', 'spm')"
            ></v-date-picker>
          </v-menu>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-menu
            v-model="menu_datePicker_receipt_date"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :readonly="!$can('upsert', 'spm')"
          >
            <template slot="activator">
              <v-text-field
                clearable
                v-model="item.receipt_date"
                label="Receipt Date"
                readonly
                :rules="validators.spm.receipt_date"
              ></v-text-field>
            </template>
            <v-date-picker
              dark
              v-model="item.receipt_date"
              no-title
              @input="menu_datePicker_receipt_date = false"
              :readonly="!$can('upsert', 'spm')"
            ></v-date-picker>
          </v-menu>
        </v-flex>


        <v-flex xs12 sm1 md1>
          <v-text-field
            label="Age"
            v-model="item.age"
            type="number"
            :readonly="!$can('upsert', 'spm')"
          ></v-text-field>
        </v-flex>


        <v-flex xs12 sm3 md3>
          <v-select
            label="SPM Type"
            v-model="item.spm_type"
            clearable
            :items="[
              'Acute leukemia',
              'MDS',
              'Lymphoma',
              'Solid skin tumour',
              'Solid tumour (excl. skin)',
              'Other',
            ]"
            :readonly="!$can('upsert', 'spm')"
          ></v-select>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-text-field
            label="Specify SPM Other"
            v-model="item.spm_other"
            type="text"
            :disabled="item.spm_type != 'Other'"
            :readonly="!$can('upsert', 'spm')"
          ></v-text-field>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-menu
            v-model="menu_datePicker_diagnosis_date"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :readonly="!$can('upsert', 'spm')"
          >
            <template slot="activator">
              <v-text-field
                clearable
                v-model="item.diagnosis_date"
                label="Date of diagnosis"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker
              dark
              v-model="item.diagnosis_date"
              no-title
              @input="menu_datePicker_diagnosis_date = false"
              :readonly="!$can('upsert', 'spm')"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-checkbox
            label="Trial related"
            v-model="item.trial_related"
            v-bind:false-value="0"
            v-bind:true-value="1"
            :readonly="!$can('upsert', 'spm')"
          ></v-checkbox>
        </v-flex>


        <v-flex xs12 sm3 md3>
          <v-text-field
            label="Trial medications"
            v-model="item.trial_medication"
            type="text"
            :readonly="!$can('upsert', 'spm')"
          ></v-text-field>
        </v-flex>


        <v-flex xs12 sm3 md3>
          <v-select
            label="Outcome"
            v-model="item.outcome"
            clearable
            :items="[
              'Recovered',
              'Recovered with sequelae',
              'Not yet recovered',
              'Death',
              'Ongoing at the end of study',
              'Unknown (lost to follow up)',
              'Not applicable',
            ]"
            :readonly="!$can('upsert', 'spm')"
          ></v-select>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-menu
            v-model="menu_datePicker_spm_recovered_date"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :readonly="!$can('upsert', 'spm')"
          >
            <template slot="activator">
              <v-text-field
                clearable
                v-model="item.spm_recovered_date"
                label="SPM recovered date"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker
              dark
              v-model="item.spm_recovered_date"
              no-title
              @input="menu_datePicker_spm_recovered_date = false"
              :readonly="!$can('upsert', 'spm')"
            ></v-date-picker>
          </v-menu>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-menu
            v-model="menu_datePicker_death_date"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :readonly="!$can('upsert', 'spm')"
          >
            <template slot="activator">
              <v-text-field
                clearable
                v-model="item.death_date"
                label="Death date"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker
              dark
              v-model="item.death_date"
              no-title
              @input="menu_datePicker_death_date = false"
              :readonly="!$can('upsert', 'spm')"
            ></v-date-picker>
          </v-menu>
        </v-flex>


        <v-flex xs12 sm2 md2>
          
          <!--v-select
            clearable
            md4
            v-model="item.status"
            :items="['Open', 'Close', 'Warning', 'Query']"
            label="Status"
            :readonly="!$can('upsert', 'spm')"
          ></v-select-->


           <v-tooltip top min-width='500px' :disabled="!item.errors">
              <template slot="activator" slot-scope="{ on }">
                  <div v-on="on" >
                    
                      <v-select
                        clearable
                        md4
                        v-model="item.status"
                        :items="['Open', 'Close', 'Warning', 'Query', 'Canceled']"
                        label="Status"
                        :readonly="!$can('upsert', 'spm')"
                      ></v-select>
                    
                    
                  </div>
                </template>
                <span>{{item.errors}}</span>
          </v-tooltip>


        </v-flex>


        <v-flex xs12 sm2 md2> 

        <v-tooltip top close-delay='300' min-width='50px'>
            <template slot="activator" slot-scope="{ on }">
                <v-btn
                    v-on="item.quality_check ? on : {}"
                    class="mx-1 font-weight-light"
                    small
                    :disabled="isNew || !$can('upsert', 'spm') || item.account.role == 'Guest' || item.account.role == 'Provider' || item.status == 'Canceled'"
                    @click="qualitycheckModal = true"
                    :color="qualitycheckColor">
                    <v-icon small>mdi-check</v-icon> &nbsp;&nbsp; Quality Check
                </v-btn>
                </template>
              <span>{{item.quality_check_date}}</span>
          </v-tooltip>  

        </v-flex>


        <v-flex xs12 text-xs-right>

          <v-btn
            color="pink"
            dark
            class="mx-1 font-weight-light"
            small
            dense
            @click="$router.go(-1)">
            <v-icon small>mdi-arrow-left</v-icon>
          </v-btn>

          
          <v-tooltip top close-delay='2000' min-width='400px' v-if="item.pdf">
            <template slot="activator" slot-scope="{ on }">
                <v-btn
                    v-on="item.pdf ? on : {}" 
                    small
                    class="mx-1 font-weight-light"
                    :disabled="isNew || !$can('upsert', 'spm') || item.status == 'Canceled'"
                    @click="pickFile"
                    :color="item.pdf ? 'green' : 'pink' ">
                    <v-icon small>mdi-upload</v-icon> &nbsp;&nbsp; PDF
                    &nbsp;&nbsp;
                    <v-btn v-if="canRemovePdf" color="pink" class="remove-pdf" @click.stop="removePDF()">
                      X
                    </v-btn>
                </v-btn>
              </template>
              <span><a @click="downloadPdf">{{item.pdf}}</a></span>
          </v-tooltip>
          <!-- Per evitare bug grafici dovuti al tooltip ho duplicato il bottone -->
          <v-btn v-else
              v-on="item.pdf ? on : {}" 
              small
              class="mx-1 font-weight-light"
              :disabled="isNew || !$can('upsert', 'spm') || item.status == 'Canceled'"
              @click="pickFile"
              :color="'pink'">
              <v-icon small>mdi-upload</v-icon> &nbsp;&nbsp; PDF
          </v-btn>


          <v-tooltip top min-width='200px'>
            <template slot="activator" slot-scope="{ on }">
                <v-btn
                  v-on="item.company_notification_date ? on : {}" 
                  class="mx-1 font-weight-light"
                  :disabled="isNew || !item.pdf || !$can('upsert', 'spm') || item.status == 'Canceled'"
                  @click="notifyCompany()"
                  small
                  :color="item.company_notification_date ? 'green' : 'pink' "
                  >
                  <v-icon small>mdi-email-send</v-icon>  &nbsp;&nbsp; Company</v-btn>
              </template>
              <span>Notified on {{item.company_notification_date}}</span>
          </v-tooltip>


          <v-tooltip top min-width='200px'>
            <template slot="activator" slot-scope="{ on }">
                <v-btn
                  v-on="item.medical_notification_date ? on : {}" 
                  class="mx-1 font-weight-light"
                  :color="item.medical_notification_date ? 'green' : 'pink' "
                  :disabled="isNew || !item.pdf || !$can('upsert', 'spm') || item.status == 'Canceled'"
                  small
                  @click="notifyMedicalMonitor()"
                  >
                  <v-icon small>mdi-email-send</v-icon>  &nbsp;&nbsp; Medical Monitor</v-btn>
              </template>
              <span>Notified on {{item.medical_notification_date}}</span>
          </v-tooltip>


          <v-btn
            class="mx-1 font-weight-light"
            color="purple"
            small
            :disabled="(!checkSave() && !validForm)  || item.status == 'Canceled'"
            @click="save()"
            v-if="$can('upsert', 'spm')"
            >Save</v-btn
          >
        </v-flex>

        <!-- <v-flex xs12 v-if="$can('read', 'audittrail')">
          <safety-audittrail-timeline v-if="!isNew" entity="spm" :entity_id="$route.params.id" />
        </v-flex> -->

        <input
          id="file"
          ref="file"
          type="file"
          style="display: none"
          accept=".pdf, application/pdf"
          @change="handleFileUpload()"
        />

      </v-layout>
    </v-form>


    <v-layout justify-center wrap white v-if="loadError">
      <v-flex xs12 sm12 md12>
        <v-alert type="warning" :value="true">
          ERROR Loading Pregnancy record!
        </v-alert>
      </v-flex>
    </v-layout>


    <v-dialog v-model="notifyModal" persistent max-width="1100px">
      <material-card color="primary" :title="'Notify ' + notifyType + ' (' + item.cin + ')'">
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm12 md12>
                <v-autocomplete
                  clearable
                  md4
                  chips
                  box
                  multiple
                  v-model="confirmed_emails_to_notify"
                  :items="emails_to_notify"
                  label="Email Address"
                >
                
                <template slot="selection" slot-scope="data">
                  <v-chip :color="userTypeColor[data.item.type]" class="chip--select-multi">
                    {{ data.item.email }}
                  </v-chip>
                </template>

                <template slot="item" slot-scope="data">
                  <template v-if="!isObject(data.item)">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-action>
                      <v-checkbox v-model="confirmed_emails_to_notify.filter( s => s.email == data.item.email).length"> </v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-html=" '(' + data.item.name + ') ' + data.item.email">  </v-list-tile-title>
                      <v-list-tile-sub-title :style="'color:' + userTypeColor[data.item.type]"  v-html="data.item.typeStr || data.item.type"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
                
                </v-autocomplete>
              </v-flex>


              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Email Subject"
                  v-model="emailSubject"
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-textarea
                  label="Email Body"
                  v-model="emailBody"
                  rows="18"
                  clearable
                ></v-textarea>
              </v-flex>


            </v-layout>
          </v-container>
        </v-form>

        <v-flex xs12 text-xs-right>
          <v-btn class="mx-1 font-weight-light" color="success" @click="notifyModal = false; emails_to_notify = confirmed_emails_to_notify = []">Close</v-btn>

          <v-btn
            class="mx-1 font-weight-light"
            color="pink"
            :disabled="!confirmed_emails_to_notify.length || !$can('upsert', 'spm')"
            @click="confirmNotify()"
            >Notify now</v-btn
          >
        </v-flex>
      </material-card>
    </v-dialog>

     <safety-pdf-preview-modal v-model="pdfPreview" :item="item" itemType="spm"/>
     <safety-qualitycheck-modal v-model="qualitycheckModal" :itemEvent.sync="item" eventType="spm"/>
     <safety-cin-modal v-model="chooseInitial" :title="chooseInitialTitle" :initialsList="initialsList" :choosed.sync="choosedInitial" />


    <v-dialog v-model="anotherInitial" persistent max-width="800px">
      <material-card color="primary" title="Another SPM with the same Report Date and Patient. Are you Sure?">
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
               
                 <v-data-table
                  :items="[anotherInitialSae]"
                  hide-actions
                >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th class="text-xs-left">Cin</th>
                    <th class="text-xs-left">Report Date</th>
                    <th class="text-xs-left">Receipt Date</th>
                    <th class="text-xs-left">SPM type</th>
                  </tr>
                </template>
                <template slot="items" slot-scope="{ item }" >
                  <td class="text-xs-left"><b>{{ item.cin }}</b></td>
                  <td class="text-xs-left">{{ item.report_date }}</td>
                  <td class="text-xs-left">{{ item.receipt_date }}</td>
                  <td class="text-xs-left">{{ item.spm_type }}</td>
                </template>
              </v-data-table>

              </v-flex>
            </v-layout>
          </v-container>
        </v-form>

        <v-flex xs12 text-xs-right>
          <v-btn class="mx-1 font-weight-light" color="success" @click="anotherInitial = false">Close</v-btn>

           <v-btn
            class="mx-1 font-weight-light"
            color="pink"
            @click="choosedInitial = anotherInitialSae_nextCin; anotherInitial = false;">Confirm</v-btn>

        </v-flex>

      </material-card>
    </v-dialog>


  </v-container>
</template>

<script>
import { getList as getPREList, upsert, getDetail, uploadPdf, removePdf, downloadPdf, nextCin, notifySpm } from "@/api/spm";
import validators from "@/utils/validators";
import { getList as getSites } from "@/api/site";
import { getList as getProtocolSites } from "@/api/protocol_site";
import { getCompanyUserBySpm } from "@/api/company_user";
import { getList as getExternalUser } from "@/api/external_user";
import { emailBody, emailSubject } from "@/utils/spm_mail";

export default {
  inheritAttrs: false,
  data() {
    return {
      item: {protocol:{}},
      validForm: true,
      validators,
      menu_datePicker_receipt_date: false,
      menu_datePicker_death_date: false,
      menu_datePicker_diagnosis_date: false,
      menu_datePicker_report_date: false,
      menu_datePicker_spm_recovered_date: false,
      siteSearchString: "",
      loadingSites: false,
      sites: [],
      extuserSearchString: "",
      loadingExtUser: false,
      external_users: [],
      openTreatments: false,
      selectedSite: null,
      selectedProtocol: null,
      pdf: null,
      notifyModal: false,
      emails_to_notify: [],
      confirmed_emails_to_notify: [],
      notifyType: null,
      emailBodySend: null,
      emailSubjectSend: null,
      userTypeColor: {
        'Personnel' : '#adcc46',
        'Medical monitor' : '#ff9494',
        'Company user' : '#f3ac33',
      },
      realStatus: null,
      cin: null,
      choosedInitial: null,
      pdfPreview: false,
      qualitycheckModal: false,

      chooseInitial: false,
      chooseInitialTitle: '',
      initialsList: [],
      choosedInitial: null,
      anotherInitial: false,
      anotherInitialSae: {},
      anotherInitialSae_nextCin: null,
      loadError: false
    };
  },
  created() {
    this.$store.dispatch("app/sponsorsDisabled", true);
  },
  mounted() {

    if (this.$route.params.id) {
      this.getData(this.$route.params.id);
    }
  },
  watch: {
    siteSearchString(val, oldVal) {
      if (!val) {
        this.sites = [];
        return;
      }
      this.loadingSites = true;
      getProtocolSites({ "site.name": "%" + val + "%", "protocol_id" : this.item.protocol_id }, { rowsPerPage: null }).then(data => {
        const sites = data.data.map(el => {
          return el['site'];
        });
        this.sites = sites;
        this.loadingSites = false;
      });
    },
    selectedSite(v) {
      if (v) {
        this.item.site_id = v.id;
      }
    },
    selectedProtocol(v) {
      if (v) {
        this.item.protocol_id = v.id;
      } else {
        this.sites = [];
        this.selectedSite = null;
        this.item.site_id = null;
        this.item.protocol_id = null;
      }
    },
    extuserSearchString(val, oldVal) {
      if (!val) {
        this.sites = [];
        return;
      }
      this.loadingExtUser = true;
      getExternalUser(
        { name: val + "%", protocol_id: this.item.protocol_id },
        { rowsPerPage: null }
      ).then(data => {
        this.external_users = data.data;
        this.loadingExtUser = false;
      });
    },
    choosedInitial(v) {
      this.cin = v;
      this.item.cin = v;
    },
  },
  asyncComputed: {
    // cin: {
    //   async get() {
    //     if (
    //       (this.isNew || this.warningMode) &&
    //       this.selectedSite &&
    //       this.selectedProtocol &&
    //       this.item.patient_id &&
    //       this.item.report_date &&
    //       this.item.case_type
    //     ) {
         
    //       const nextCinData = {
    //         country_code: this.selectedSite.country_code,
    //         protocol_id: this.selectedProtocol.id,
    //         patient_id: this.item.patient_id,
    //         case_type: this.item.case_type,
    //         report_date: this.item.report_date
    //       };

    //       return nextCin(nextCinData).then( (data) => {
    //         this.cin = this.item.cin = data.nextCIN;
    //         return data.nextCIN;
    //       }).catch( e => {
    //         console.error(e.response.data.message)
    //         this.cin = this.item.cin = null;

    //         this.$store.dispatch("app/openSnackbar", {
    //           message: "CIN error, please check data : " +  e.response.data.message,
    //           color: "error"
    //         });
    //         return null

    //       });

          
    //     }
    //     return this.isNew ? null : this.item.cin;
    //   },
    //   set(v) {
    //     this.item.cin = v;
    //   }
    // },
  },
  computed: {
    canRemovePdf(){
      return ['Administrator','Employee'].includes(this.$store.getters.userObj.role ) && this.item.pdf ? true : false
    },
    protocols() {
      return this.$store.getters.protocols;
    },
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return this.isNew ? "New SPM Report" : "Edit SPM Report";
    },
    emailBody: {
      get() {
        const def = emailBody(this.item, this.notifyType);
        this.emailBodySend = def;
        return def;
      },
      set(v) {
        this.emailBodySend = v;
      }
    },
    emailSubject: {
      get() {
        const def = emailSubject(this.item, this.notifyType);
        this.emailSubjectSend = def;
        return def;
      },
      set(v) {
         this.emailSubjectSend = v;
      }
    },
    warningMode() {
      return this.realStatus == 'Warning';
    },
    qualitycheckColor() {
      if (this.item.quality_check) {
        return 'green';
      }
      return 'pink'
    }
  },
  methods: {
    removePDF(){
      this.$store.dispatch("app/startLoading");
      removePdf(this.item.id)
      .then((data)=>{
        if(data){
          this.$store.dispatch("app/stopLoading");
          this.item.pdf=''
        }
      })
      .catch(() => {
        this.$store.dispatch("app/openSnackbar", {
          message:
            "An Error occurred during pdf delete " +
            e.response.data.message,
          color: "error"
        });
        this.$store.dispatch("app/stopLoading");
      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
    },
    getData(id) {
      return getDetail(id, this.projectId).then(data => {
        // const newItem = JSON.parse(JSON.stringify(data).replace('""', /null/i));
        this.realStatus = data.status;
        this.item = data;
        this.sites = [this.item.site];
        this.selectedSite = this.item.site;
        this.selectedProtocol = this.item.protocol;
        this.cin = this.item.cin

        this.$store.commit("app/spmItem", data);
        this.$store.dispatch("app/loadSponsors");
        this.loadError = false
      }).catch( e => {
        this.loadError = true
      });
    },
    calculateCin() {
      if (
          (this.isNew || this.warningMode) &&
          this.selectedSite &&
          this.selectedProtocol &&
          this.item.patient_id &&
          // this.item.report_date &&
          this.item.case_type
      ) {

        const nextCinData = {
          country_code: this.selectedSite.country_code,
          protocol_id: this.selectedProtocol.id,
          patient_id: this.item.patient_id,
          case_type: this.item.case_type,
          // report_date: this.item.report_date,
          current_id: this.item.id
        };

        return nextCin(nextCinData).then( (data) => {
          this.cin = this.item.cin = data.nextCIN;
          return data.nextCIN;
        }).catch( e => {
          
          this.cin = this.item.cin = null;
          
          const errorData = e.response.data;

          // // choose initial for this follow up
          if (errorData.error_details && errorData.error_details.errorCode == 'multiple_initials') {
            this.initialsList = errorData.error_details.initials;
            this.chooseInitialTitle =  "Multiple Initial case found for this SAE";
            this.chooseInitial = true;
            return null;
          }

          //   // confirm double initial for the same date
          if (errorData.error_details && errorData.error_details.errorCode == 'another_initial') {
            this.anotherInitialSae = errorData.error_details.initial;
            this.anotherInitialSae_nextCin = errorData.error_details.nextCin;
            this.anotherInitial = true;
            return null;
          }

          //   // no initial found...possibly onset date error
          if (errorData.error_details && errorData.error_details.errorCode == 'no_initial' && errorData.error_details.initials.length) {
            this.initialsList = errorData.error_details.initials;
            this.chooseInitialTitle =  "No Initial case found for this SAE. OnSet Date is changed?";
            this.chooseInitial = true;
            return null;
          }

          this.$store.dispatch("app/openSnackbar", {
            message: "CIN error, please check data : " +  errorData.message,
            color: "error"
          });
          return null

        });
      } else {
        this.cin =  this.isNew ? null : this.item.cin;
      }

    },
    calculateAge() {
      let age = new Date().getFullYear() - this.item.year_of_birth;
      this.item.age = null;
      if (age > 10 && age < 100) {
        this.item.age = age;
      }
    },
    checkSave() {
      return !this.isNew;
    },
    customArmTxt(arm) {
      return arm.rnd + ' - ' + arm.key;
    },
    customArmValue(arm) {
      return arm.key;
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      upsert(this.item)
        .then(data => {

          this.$store.dispatch("app/openSnackbar", {
            message: this.isNew ? "SPM created correctly" : "SPM updated correctly",
            color: "success"
          });

          this.getData(data.data.id);

        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the SPM update. " +
              e.response.data.message,
            color: "error"
          });
        });
    },
    notifyCompany() {

       // get company users
      getCompanyUserBySpm(
        { spm: this.item }
      ).then(cue => {
        const cueel = cue.map( el => { 
          el['type'] = 'Company user'; 
          el['typeStr'] = 'Company user (' + el.company.name + ')'; 
          return el; 
        });
       // get external user (Personnel)
        getExternalUser(
          { protocol_id: this.item.protocol_id, type: 'Personnel' },
          { rowsPerPage: null }
        ).then(etn => {
          // const etn = data.data.map( el => {return el.email; });
          this.emails_to_notify = this.confirmed_emails_to_notify = [...cueel, ...etn.data];//[...new Set(cue), ...new Set(etn)];
        });

      });

      this.notifyType = 'Company';
      this.notifyModal = true;
    },
    notifyMedicalMonitor() {

      getExternalUser(
        { protocol_id: this.item.protocol_id, type: 'Medical Monitor' },
        { rowsPerPage: null }
      ).then(etn => {
        // const etn = data.data.map( el => {return el.email; });
        this.emails_to_notify = this.confirmed_emails_to_notify = etn.data;//[...new Set(etn)];
      });

      this.notifyType = 'Medical Monitor';
      this.notifyModal = true;
    },
    closeNotify() {
      this.notifyModal = false;
    },
    confirmNotify() {

      const notifyParams = {
        id : this.item.id,
        type : this.notifyType,
        emailSubject : this.emailSubjectSend,
        emailBody : this.emailBodySend,
        to: this.confirmed_emails_to_notify
      };

      notifySpm(notifyParams).then( data => {

        this.$store.dispatch("app/openSnackbar", {
          message: "SPM Event correctly notified to " + this.notifyType,
          color: "success"
        });

        if (data.company_notification_date) {
          this.item.company_notification_date = data.company_notification_date;
        }
        if (data.medical_notification_date) {
          this.item.medical_notification_date = data.medical_notification_date;
        }

      }).catch( e => {
         this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the SPM Report " + this.notifyType + " notify. " +
              e.response.data.message,
            color: "error"
          });
      }).finally( () => {
         this.$store.dispatch("app/stopLoading");
      });

      this.notifyModal = false;
      this.$store.dispatch("app/startLoading");

    },
    pickFile() {
      this.$refs.file.click();
    },
    handleFileUpload(event) {

      const file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      this.$store.dispatch("app/startLoading");
      let formData = new FormData();
      formData.append('file', file);
      formData.append('id', this.item.id);

      uploadPdf(formData).then( data => {
        this.item.pdf = data.pdf;
        //issue 679
        this.save();
        //issue 679
      }).catch( (e) => {
        this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during pdf upload " +
              e.response.data.message,
            color: "error"
          });
      }).finally( () => {
         this.$store.dispatch("app/stopLoading");
      });
      this.$refs.file.value = '';
    },
    downloadPdf() {

      this.pdfPreview = true
      
      // this.$store.dispatch("app/startLoading");
      // downloadPdf(this.item.id, this.item.pdf).then( d => {
      // }).catch( e => {
      //     this.$store.dispatch("app/openSnackbar", {
      //       message:
      //         "An Error occurred during pdf upload " +
      //         e.response.data.message,
      //       color: "error"
      //     });
      // }).finally( () => {
      //    this.$store.dispatch("app/stopLoading");
      // });
    },
    searchCenter() {
      if (this.item.protocol_id && this.item.patient_id) {
        getPREList({protocol_id: this.item.protocol_id, patient_id: this.item.patient_id}, {rowsPerPage: null}).then( data => {
          if(data.tot > 0) {
            this.sites = [data.data[0].site];
            this.selectedSite = data.data[0].site;
          } else {
            this.selectedSite = {}
          }
        });
      }
    },
    isObject(v) {
      return typeof v == 'object'
    }
  }
};
</script>

<style>

.remove-pdf{
  margin: 0;
  padding: 0; 
  min-width: 30%;
  min-height: 0;
}

#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}

.spm_upsert .v-select__selection--comma {
  max-width: 200px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

</style>
